module.exports = __webpack_public_path__ + "img/event-1.d81f8d0d.png";